import {
  getAdvertisersBudgetInfo,
  AdvertisersBudgetInfoResponse,
  GetAdvertisersBudgetInfoArgs,
} from 'api/services';
import { UseQueryOptions, useQuery } from 'react-query';
import { ParsedAdvertisersBudgetInfoData } from '../types';
import { promoMetricsQueries } from './queryKeys';
import { promoCampaingsBudgetSelector } from './selectors';

type QueryKey = ReturnType<typeof promoMetricsQueries.campaignBudget>;

function useAdvertisersCampaignBudgetMetrics<TData = unknown>(
  args: GetAdvertisersBudgetInfoArgs,
  opts?: Omit<
    UseQueryOptions<AdvertisersBudgetInfoResponse, unknown, TData, QueryKey>,
    'queryKey' | 'queryFn'
  >,
) {
  return useQuery<AdvertisersBudgetInfoResponse, unknown, TData, QueryKey>(
    promoMetricsQueries.campaignBudget(args),
    () => getAdvertisersBudgetInfo(args),
    opts,
  );
}

export function usePromoCampaignBudgetMetrics(
  args: GetAdvertisersBudgetInfoArgs,
  opts?: Omit<
    UseQueryOptions<
      AdvertisersBudgetInfoResponse,
      unknown,
      ParsedAdvertisersBudgetInfoData,
      QueryKey
    >,
    'queryKey' | 'queryFn'
  >,
) {
  return useAdvertisersCampaignBudgetMetrics(args, {
    select: promoCampaingsBudgetSelector,
    ...opts,
  });
}
